var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTtoSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24881 2.66623C4.71167 2.94347 4.20746 3.30687 3.75718 3.75715C3.30688 4.20745 2.94348 4.71167 2.66626 5.24881L6.52423 9.47573L10.7512 13.3337C11.2883 13.0565 11.7925 12.6931 12.2428 12.2428C12.6931 11.7925 13.0565 11.2883 13.3337 10.7512L9.47576 6.5242L5.24881 2.66623Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2428 12.2428C12.4945 11.9911 12.719 11.7225 12.9166 11.4409L4.55914 3.08337C4.27744 3.28098 4.00887 3.50546 3.75718 3.75715C3.50548 4.00885 3.281 4.27742 3.08337 4.55914L11.4408 12.9166C11.7225 12.719 11.9911 12.4945 12.2428 12.2428Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75715 12.2428C5.65013 14.1358 8.49303 14.4992 10.7511 13.3337L2.66626 5.24881C1.50083 7.50692 1.86427 10.3498 3.75715 12.2428Z",
    fill: "#D80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2428 3.75718C10.3498 1.86423 7.50689 1.50086 5.24878 2.66624L13.3337 10.7512C14.4991 8.49308 14.1357 5.65014 12.2428 3.75718Z",
    fill: "#D80027"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtoSm);
export default __webpack_public_path__ + "static/media/TTO-SM.e72e23f7b97c5ab39df2c9a08d8e43ae.svg";
export { ForwardRef as ReactComponent };